<div class="header">
  <div class="outlined-large-button" title="clean settings">
    <div class="buttons-medium-button-active-outlined">clean settings</div>
  </div>
  <div class="outlined-large-button-icon-left" title="export settings">
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4535 21.5216C14.2183 21.5216 13.9927 21.4282 13.8264 21.2619C13.66 21.0955 13.5666 20.8699 13.5666 20.6347V17.0972C11.6523 17.1864 6.89183 17.7707 3.56403 21.2482C3.43424 21.3839 3.26473 21.4749 3.07993 21.5081C2.89512 21.5413 2.70455 21.515 2.53565 21.4329C2.36675 21.3509 2.22823 21.2174 2.14005 21.0517C2.05186 20.8859 2.01855 20.6964 2.04493 20.5105C3.48686 10.3224 10.9551 8.57668 13.5666 8.27821V4.66934C13.5666 4.48951 13.6213 4.31394 13.7234 4.16591C13.8255 4.01787 13.9701 3.90436 14.1382 3.84043C14.3063 3.77649 14.4898 3.76515 14.6645 3.80791C14.8391 3.85067 14.9967 3.94551 15.1162 4.07986L22.2119 12.0625C22.3563 12.2249 22.4361 12.4347 22.4361 12.652C22.4361 12.8693 22.3563 13.0791 22.2119 13.2415L15.1162 21.2242C15.0331 21.3178 14.931 21.3927 14.8168 21.444C14.7026 21.4952 14.5788 21.5217 14.4535 21.5216ZM14.0975 15.306C14.3227 15.306 14.4612 15.312 14.4977 15.3142C14.725 15.3256 14.9392 15.4238 15.0961 15.5886C15.2529 15.7535 15.3405 15.9723 15.3405 16.1999V18.302L20.3626 12.652L15.3405 7.00205V9.10415C15.3406 9.22187 15.3172 9.33842 15.2717 9.44699C15.2261 9.55556 15.1595 9.65397 15.0755 9.73647C14.9013 9.89602 14.675 9.98656 14.4388 9.99112C14.0637 9.98287 6.7351 10.0076 4.32965 18.267C7.22693 16.348 10.6224 15.3187 14.0975 15.306Z"
        fill="black"
      />
    </svg>
    <div class="buttons-medium-button-active-outlined">Export</div>
  </div>
  <div class="outlined-large-button-icon-left" title="import settings">
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6807_461)">
        <path
          d="M12.9863 14.0839V21.3564C12.9863 21.7706 12.6505 22.1064 12.2363 22.1064C11.8221 22.1064 11.4863 21.7706 11.4863 21.3564V14.0838L9.47909 16.0911C9.33266 16.2376 9.1407 16.3108 8.9488 16.3108C8.75689 16.3108 8.56494 16.2376 8.4185 16.0911C8.12558 15.7982 8.12558 15.3234 8.4185 15.0305L11.706 11.7429C11.8467 11.6022 12.0374 11.5232 12.2363 11.5232C12.4352 11.5232 12.626 11.6022 12.7666 11.7429L16.0542 15.0305C16.3471 15.3234 16.3471 15.7982 16.0542 16.0911C15.7613 16.384 15.2864 16.384 14.9936 16.0911L12.9863 14.0839ZM23.0545 11.0512C22.3908 10.2345 21.4947 9.63127 20.5 9.32452C19.7051 7.53643 17.9203 6.36118 15.9384 6.36118C15.8089 6.36118 15.6791 6.36624 15.5497 6.37632C15.0489 5.50974 14.3498 4.77184 13.5042 4.22204C12.474 3.55229 11.2775 3.19824 10.0438 3.19824C6.58348 3.19824 3.76002 5.97765 3.6882 9.42113C2.78272 9.75816 1.97492 10.3439 1.37155 11.1094C0.6395 12.0383 0.236328 13.1968 0.236328 14.3716C0.236328 17.2823 2.60436 19.6503 5.51506 19.6503H8.87023C9.28442 19.6503 9.62023 19.3146 9.62023 18.9003C9.62023 18.4861 9.28442 18.1503 8.87023 18.1503H5.51506C3.43147 18.1503 1.73633 16.4552 1.73633 14.3716C1.73633 12.6506 2.95292 11.106 4.62912 10.6988C4.98537 10.6123 5.22687 10.2809 5.20011 9.91524C5.1913 9.79477 5.1868 9.6737 5.1868 9.55524C5.1868 6.87709 7.36564 4.69824 10.0438 4.69824C11.9242 4.69824 13.6531 5.80027 14.4483 7.50582C14.5937 7.81768 14.9327 7.99037 15.2705 7.92521C15.4901 7.88274 15.7148 7.86118 15.9384 7.86118C17.4208 7.86118 18.7454 8.80084 19.2346 10.1994C19.3201 10.4439 19.5258 10.627 19.7786 10.6836C21.4925 11.0675 22.7363 12.6185 22.7363 14.3716C22.7363 16.4552 21.0412 18.1503 18.9576 18.1503H15.6024C15.1882 18.1503 14.8524 18.4861 14.8524 18.9003C14.8524 19.3146 15.1882 19.6503 15.6024 19.6503H18.9576C21.8683 19.6503 24.2363 17.2823 24.2363 14.3716C24.2363 13.1682 23.8166 11.989 23.0545 11.0512Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_6807_461">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.236328 0.652344)"
          />
        </clipPath>
      </defs>
    </svg>
    <div class="buttons-medium-button-active-outlined">Import</div>
  </div>
</div>
<div class="main">
  <mat-tab-group
    animationDuration="0ms"
    mat-stretch-tabs="false"
    mat-align-tabs="start"
  >
    <mat-tab label="General Settings">
      <div class="view">
        <div class="categories">
          <ul>
            <li>AI Detections</li>
          </ul>
        </div>
        <div class="form">
          <fieldset id="item-settings-ai-detections">
            <legend>AI Detections</legend>
            <div class="form-group">
              <span>Scaling Factor</span>
              <mat-slider min="1.0" max="1.5" step="0.1" discrete>
                <input
                  (valueChange)="onAIDetectionScalingFactorChange($event)"
                  matSliderThumb
                  [value]="settings.aiDetections.scalingFactor"
                />
              </mat-slider>
              <pre>{{ settings.aiDetections.scalingFactor }}</pre>
            </div>
          </fieldset>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
